<template>
    <Card>
        <template v-slot:header>
            <h2>顾客年龄分布</h2>
        </template>
        <div class="card-content">
            <ChartMap class="chart-big" ref="chart"></ChartMap>
        </div>
    </Card>
</template>
<script>
import ChartMap from "../../components/ChartMap.vue";
export default {
    name: "FlowRank",
    components: { ChartMap },
    data() {
        return {};
    },
    mounted() {
        let opt = this.getOptions();
        this.$refs.chart.setData(opt);
    },
    methods: {
        getOptions() {
            let option = {
                legend: {
                    top: "bottom",
                },
                toolbox: {
                    show: true,
                    feature: {
                        mark: { show: true },
                        dataView: { show: true, readOnly: false },
                        restore: { show: true },
                        saveAsImage: { show: true },
                    },
                },
                series: [
                    {
                        name: "面积模式",
                        type: "pie",
                        radius: [50, 200],
                        center: ["50%", "50%"],
                        roseType: "area",
                        itemStyle: {
                            borderRadius: 8,
                        },
                        data: [
                            { value: 40, name: "18岁以内" },
                            { value: 38, name: "19-25岁" },
                            { value: 32, name: "26-35岁" },
                            { value: 30, name: "36-45岁" },
                            { value: 28, name: "46-60岁" },
                            { value: 26, name: "60岁以上" },
                        ],
                    },
                ],
            };
            return option;
        },
    },
};
</script>
